const DefaultValuesDEV = {
    HOME: "https://dev.7gates.exchange/",
    CLIENT: "https://dev.7gates.exchange/client/",
    PAY: "https://devpay.7gates.exchange/",
    SECURE: "https://devsecure.7gates.exchange/"
};

const DefaultValuesProd = {
    HOME: "https://7gates.exchange/",
    CLIENT: "https://7gates.exchange/client/",
    PAY: "https://pay.7gates.exchange/",
    SECURE: "https://secure.7gates.exchange/"
};

export var DefaultValues = DefaultValuesProd;

export function initVars(is_dev: boolean) {
    if (is_dev) {
        DefaultValues = DefaultValuesDEV;
    }
}
